import {
  fontFamilies,
  spacing,
  typeScale,
} from '@airship-platform/jam-design-tokens';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { platformComponents } from './components';
import { platformPalette } from './palette';

export const platformTheme = responsiveFontSizes(
  createTheme({
    palette: platformPalette,
    typography: {
      fontFamily: fontFamilies.body,
      ...typeScale,
    },
    components: platformComponents,
    spacing: (factor: number) => spacing(factor),
  })
);
